const ISTEST = import.meta.env.MODE !== 'production'

const logger = {
  debug: (...data: any[]) => ISTEST && console.debug(...data),
  log: (...data: any[]) => ISTEST && console.log(...data),
  warm: (...data: any[]) => ISTEST && console.warn(...data),
  error: (...data: any[]) => ISTEST && console.error(...data),
}
export { logger }
